<template>
    <div class="user-avatar">
        <v-avatar
            :size="size"
            color="primary"
        >
            <v-img
                v-if="imageUrl"
                :src="imageUrl"
            />
            <div
                v-else
                class="text-center font-weight-medium"
                :style="{
                    'font-size': `${Math.max(0.5, 0.05 * (size / 2))}rem`,
                    'line-height': 1
                }"
            >
                {{ initials }}
            </div>
        </v-avatar>
    </div>
</template>
<script setup lang="ts">
import { computed } from "vue";
import { UserAvatarProps } from "./user-avatar.types";

const props = withDefaults(defineProps<UserAvatarProps>(), {
    size: 40
});

const initials = computed(() => {
    let i = "??";

    if (props.name) {
        const SPL = props.name.split(" ");
        if (SPL[0]) {
            i = SPL[0][0];
        }
        if (SPL.length > 1) {
            if (SPL[SPL.length - 1]) {
                i += SPL[SPL.length - 1][0];
            }
        }
    }

    return i.toUpperCase();
});
</script>
